import React from "react";
import { useFormContext } from "react-hook-form";
import { User, FlaskConical } from "lucide-react";
import { FaExclamationTriangle } from "react-icons/fa";
import { formatDateDDMMYYYY, formatSlotTimeDisplay } from "../HVTCommonHelpers";

const BookingReviewStep = ({ primaryBookingId }) => {
    const { watch } = useFormContext();
    const gender = watch("gender");
    const salutation = watch("salutation");
    const firstName = watch("firstName");
    const lastName = watch("lastName");
    const mobile = watch("mobile");
    const email = watch("email");
    const age = watch("age");
    const visitDate = watch("visitDate");
    const pincode = watch("pincode");
    const locationName = watch("locationName");
    const addressLine1 = watch("addressLine1") || "";
    const flatNo = watch("flatNo") || "";
    const buildingName = watch("buildingName") || "";
    const locality = watch("locality") || "";
    const landmark = watch("landmark") || "";
    const hasSplitAddress = !!(flatNo || buildingName || locality || landmark);
    const tests = watch("tests") || [];
    const selectedSlot = watch("selectedSlot");

    return (
        <>
            {!primaryBookingId && !selectedSlot && (
                <div className="alert alert-danger py-2 px-3 mb-2 d-flex align-items-center gap-2" style={{ fontSize: "13px" }}>
                    <FaExclamationTriangle /> Your slot hold has expired. Please go back and select a new slot.
                </div>
            )}

            <div className="hvt-quick-section">
                <div className="hvt-quick-section-title"><User size={13} /> Patient Details</div>
                <div className="hvt-order-grid3">
                    <div className="hvt-order-field">
                        <div className="k">Name</div>
                        <div className="v">{salutation} {firstName} {lastName}</div>
                    </div>
                    <div className="hvt-order-field">
                        <div className="k">Gender &middot; Age</div>
                        <div className="v">{gender} &middot; {age}</div>
                    </div>
                    <div className="hvt-order-field">
                        <div className="k">Mobile</div>
                        <div className="v">+91 {mobile}</div>
                    </div>
                    <div className="hvt-order-field">
                        <div className="k">Visit Date & Time</div>
                        <div className="v">{formatDateDDMMYYYY(visitDate)}{selectedSlot ? `, ${formatSlotTimeDisplay(selectedSlot.Slot_TIME)}` : ""}</div>
                    </div>
                    <div className="hvt-order-field">
                        <div className="k">Email</div>
                        <div className="v">{email || "-"}</div>
                    </div>
                    <div className="hvt-order-field">
                        <div className="k">Location</div>
                        <div className="v">{locationName || "-"} ({pincode || "-"})</div>
                    </div>
                    {hasSplitAddress ? (
                        <>
                            <div className="hvt-order-field">
                                <div className="k">Flat / House No.</div>
                                <div className="v">{flatNo || "-"}</div>
                            </div>
                            <div className="hvt-order-field">
                                <div className="k">Building Name</div>
                                <div className="v">{buildingName || "-"}</div>
                            </div>
                            <div className="hvt-order-field">
                                <div className="k">Locality</div>
                                <div className="v">{locality || "-"}</div>
                            </div>
                            <div className="hvt-order-field">
                                <div className="k">Landmark</div>
                                <div className="v">{landmark || "-"}</div>
                            </div>
                        </>
                    ) : (
                        <div className="hvt-order-field full">
                            <div className="k">Address</div>
                            <div className="v">{addressLine1 || "-"}</div>
                        </div>
                    )}
                </div>
            </div>

            <div className="hvt-quick-section">
                <div className="hvt-quick-section-title">
                    <FlaskConical size={13} /> Tests <span className="hvt-added-tests-count">{tests.length}</span>
                </div>
                <div className="hvt-added-tests-row">
                    {tests.map((t) => (
                        <div key={t.TEST_CODE} className="hvt-added-test-pill">
                            <span>{t.TEST_NAME}</span>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default BookingReviewStep;
